/**
 *
 * @export
 * @class License
 */
export class LicenseDevice{
  ProductId:    string;
	VendorId:     string;

  constructor(
    ProductId:    string,
    VendorId:     string,
  ){
    this.ProductId=    ProductId;
    this.VendorId=     VendorId;
  }
}

export class License {
  //Fields
  Version: string;
  DevicesList?: LicenseDevice[];
  Path?: string;
  NumOfClients: number;

    
  
  constructor(
    Version: string,
    NumOfClients: number,
    DevicesList?: any[],
    Path?: string,
  ) {
    this.Version= Version;
    this.NumOfClients= NumOfClients;

    this.Path= "";

    this.DevicesList=[] as LicenseDevice[]; 
    if(DevicesList!==undefined){
      DevicesList.forEach((d:any) => {
      //  console.log(d)
      const ld=new LicenseDevice(d.productId,d.vendorId);
      if (this.DevicesList!==undefined){
      this.DevicesList.push(ld);}
    })
    }  
    if(Path!==undefined){
      this.Path= Path;
    }  
      
  }
    /*
    empty(){
      this.Version= "";
      this.Path= "";
      this.DeviceList= null;
  
    }*/
  }

